import React from "react";
import "./Agroproduct.scss";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

const Agroproduct = ({ product }) => {
  const navigate = useNavigate();

  console.log(product);

  return (
    <div className="containers">
      <Helmet>
        <title>Fenton Chemicals | Agro Emulsifiers, Fertilizers & Silicone Spreaders.</title>
        <meta name="description" content="Explore Fenton Chemicals’ product categories: agro chemicals & emulsifiers, fertilizers, silicone super spreaders, paint additives, and home & industrial cleaning solutions." />
        <meta name="keywords" content="Fenton Chemicals Agro Chemicals, Agro Emulsifiers, Surfactants, Fertilizers, Chemical Exporter Indore, Agricultural Chemicals Supplier, High-Quality Agro Products" />
      </Helmet>
      <div className="innerSecton">
        {product.map((category, index) => (
          <div className="singleProduct shadow" key={index}>
            <div className="right-details">
              <h3>{category.subcategory}</h3>
              <div className="line"></div>
              <button
                onClick={() => {
                  if (category?.link) {
                    window.scrollTo({ top: 0, behavior: "smooth" });

                    if (category?.link === "/Agro") {
                      navigate(
                        `/category/${category.category.replace(/ /g, "_")}`,
                        {
                          state: { subcategories: category },
                        }
                      );
                    } else if (category?.link) {
                      navigate(category.link, {
                        state: { subcategories: category },
                      });
                    }
                  } else {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    navigate(
                      `/products/${category?.subcategory?.replace(
                        / /g,
                        "_"
                      )}/1`,
                      {
                        state: { subcategories: category },
                      }
                    );
                  }
                }}
              >
                View All
              </button>
            </div>
            <div className="left-img">
              <img src={category?.image} alt={category.name} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Agroproduct;
